(function () {
    angular.module('tmx-app').controller('businessReportsCtrl', [
        'resolvedData',
        'menu',
        'tmxUtility',
        'UsersService',
        'ReportService',
        'lookupService',
        'TMX_FINANCE_CONSTANTS',
        'LoanProductService',


        function businessReportsCtrl(resolvedData, menu, tmxUtility, UsersService, ReportService, lookupService, TMX_FINANCE_CONSTANTS, LoanProductService) {

            //#region Dev Notes
            /*
                1-The VM model names should be same as report params. For example if ReportParams has a variable user_id, then the model variable bind to that field should be model.user_id and so on
                    This is to map directly between businessReportsVM.selectedReport.requiredParams and businessReportsVM.model variables.
                2-
            */

            //#endregion

            //#region Variables Initialization
            var businessReportsVM = this;
            var todayDate = new Date();
            // eslint-disable-next-line no-useless-escape
            var lovRegex = new RegExp("lov\([\w\s:]*\)");
            businessReportsVM.menu = menu;
            businessReportsVM.activeRoles = [];
            businessReportsVM.reportTypes = [];
            businessReportsVM.selectedReport = { spName: null, requiredParams: {}, reportName: null, reportVisibleName: null };
            businessReportsVM.model = {};
            businessReportsVM.userList = [];
            businessReportsVM.locationList = [];
            businessReportsVM.productList = [];
            businessReportsVM.branchList = [];
            businessReportsVM.reportHtml = ''
            businessReportsVM.orientations = Object.keys(TMX_FINANCE_CONSTANTS.PAGE_ORIENTATION).map(key => ({ VisibleValue: key, HiddenValue: TMX_FINANCE_CONSTANTS.PAGE_ORIENTATION[key] }));
            businessReportsVM.lovParameters = [];
            businessReportsVM.wfStates = [];
            businessReportsVM.IsUserRequired = false;
            var timeZoneOffset = 0 - (new Date().getTimezoneOffset()); // need inverse of the sign that JS gives
            //#endregion

            //#region  Private Methods

            function HandleResolveData() {
                if (!tmxUtility.exists(resolvedData)) {
                    console.error('Resolved Data is empty');
                    return;
                }
                if (tmxUtility.exists(resolvedData.Roles.data)) {
                    var activeRoles = resolvedData.Roles.data.filter(role =>
                        new Date(role.EffectiveStartDate) < todayDate < new Date(role.EffectiveEndDate)
                    );
                }
                businessReportsVM.activeRoles = activeRoles.map(x => ({ LookupId: x.RoleId, VisibleValue: x.RoleName }));
                if (tmxUtility.exists(resolvedData.ReportTypes)) {
                    // Filter reports, only show those reports on which user have  rigts
                    businessReportsVM.reportTypes = resolvedData.ReportTypes.filter(report => tmxUtility.checkPermission(report.HiddenValue));
                }
                if (tmxUtility.exists(resolvedData.Branches.data)) {
                    businessReportsVM.branchList = resolvedData.Branches.data.map(x => ({ LookupId: x.CompanyBranchId, VisibleValue: x.BranchName }));
                    businessReportsVM.branchList.unshift({ LookupId: -1, VisibleValue: 'All' }); // Add to beginning of array
                }
                if (tmxUtility.exists(resolvedData.Locations)) {
                    businessReportsVM.locationList = resolvedData.Locations;
                }
                if (tmxUtility.exists(resolvedData.Products)) {
                    businessReportsVM.productList = resolvedData.Products.map(x => ({ LookupId: x.ProductId, VisibleValue: x.ProductName }));
                    businessReportsVM.productList.unshift({ LookupId: -1, VisibleValue: 'All' }); // Add to beginning of array

                }
            }

            function ResolveReportParameters(selectedReportDescription) {
                var lovTypeParams = [];
                var descArray = selectedReportDescription.split(','); // Split the comma separated description into array
                businessReportsVM.selectedReport.spName = descArray.splice(0, 1)[0]; // remove the first index from descArray and select it as spName
                businessReportsVM.selectedReport.requiredParams = {};
                descArray.forEach(item => {
                    if (lovRegex.test(item)) { // put Lovs in separate list
                        lovTypeParams.push(item);
                    }
                    else {
                        businessReportsVM.selectedReport.requiredParams[item] = true
                    }
                });
                if (lovTypeParams.length > 0) {
                    lovTypeParams.forEach(lov => populateLovTypeParameters(lov));
                }

                function populateLovTypeParameters(lov) {
                    let lovDesc = lov.substring(lov.indexOf("(") + 1, lov.lastIndexOf(')'));
                    var lovParams = lovDesc.split(':');
                    var lovRequired = 0; // default
                    if (lovParams.length < 3) {
                        console.error(`Lov parameters are not defined for LOV: '${lov}'`);
                        return;
                    }
                    if(lovParams.length >= 4) { //Optional required parameter provided
                        lovRequired = lovParams[3] == '1';
                    }
                    businessReportsVM.lovParameters.push({ paramName: lovParams[0].trim(), options: lookupService.getLocalLookupsByType(lovParams[1].trim()), label: lovParams[2].trim(), required: lovRequired });
                }
            }

            function RefreshScreen() {
                businessReportsVM.selectedReport = { spName: null, requiredParams: {}, reportName: null, reportVisibleName: null };
                businessReportsVM.model = {};
                businessReportsVM.userList = [];
                businessReportsVM.isReportFetched = false;
                businessReportsVM.lovParameters = [];
                businessReportsVM.wfStates = [];
            }

            function PrepareParametersForService() {
                var ReportVm = {};
                ReportVm.ReportVisibleName = businessReportsVM.selectedReport.reportVisibleName;
                ReportVm.ReportName = businessReportsVM.selectedReport.reportName;
                ReportVm.StoredProcedure = businessReportsVM.selectedReport.spName;
                ReportVm.Arguments = {};
                Object.keys(businessReportsVM.selectedReport.requiredParams).forEach(paramName => {
                    if (businessReportsVM.model[paramName] == undefined) {
                        ReportVm.Arguments[paramName] = null;
                    }
                    else {
                        ReportVm.Arguments[paramName] = businessReportsVM.model[paramName];
                    }
                });
                // Incorporting dynamic lov type params
                if (tmxUtility.exists(businessReportsVM.lovParameters) && businessReportsVM.lovParameters.length > 0) {
                    businessReportsVM.lovParameters.forEach(lov => {
                        ReportVm.Arguments[lov.paramName] = lov.selectedValue || '';
                    });
                }
                ReportVm.Arguments["offset"]= timeZoneOffset;
                return ReportVm;
            }


            //#endregion


            (function InitializePage() {
                HandleResolveData();
            })();

            //#region  Scope Methods
            businessReportsVM.OnReportTypeSelected = function (selectedType) {
                if (!tmxUtility.exists(selectedType)) { // In case of clear the dropdown
                    RefreshScreen();
                    return;
                }
                var selectedReport = businessReportsVM.reportTypes.find(x => x.LookupId == selectedType);
                businessReportsVM.selectedReport.reportVisibleName = selectedReport.VisibleValue;
                if (tmxUtility.exists(selectedReport, 'HiddenValue')) {
                    businessReportsVM.selectedReport.reportName = selectedReport.HiddenValue;
                }
                if (tmxUtility.exists(selectedReport, 'Description')) {
                    ResolveReportParameters(selectedReport.Description);
                }
            }

            businessReportsVM.OnRoleSelected = function (selectedRole) {
                businessReportsVM.userList = [];
                businessReportsVM.model.user_id = null;
                if (!tmxUtility.exists(selectedRole)) {
                    businessReportsVM.IsUserRequired= false;
                    return;
                }
                businessReportsVM.IsUserRequired= true;
                UsersService.getUserByRole(selectedRole).then(function (response) {
                    if (tmxUtility.exists(response, 'data')) {
                        businessReportsVM.userList = response.data.map(x => ({ LookupId: x.UserID, VisibleValue: x.UserName }));
                    }
                });

            }

            businessReportsVM.OnProductSelected = function (selectedProduct) {
                businessReportsVM.wfStates = [];
                businessReportsVM.model.wf_state = null;
                if (!tmxUtility.exists(selectedProduct)) return;
                LoanProductService.getStatesbyProduct(selectedProduct).then(function (response) {
                    if (tmxUtility.exists(response, 'data')) {
                        businessReportsVM.wfStates = response.data.filter(x => x.Name.trim() != "")
                            .map(x => ({
                                HiddenValue: x.Name,
                                VisibleValue: x.VisibleName
                            }));
                    }
                });

            }

            businessReportsVM.GetReport = function () {
                var ReportVm = PrepareParametersForService();
                firebase.logTmxEvent('business_report', { name: ReportVm.ReportVisibleName });
                ReportService.ReportHTML(ReportVm).then(function (response) {
                    //console.log(response);
                    if (response.status.code == 200) {
                        businessReportsVM.isReportFetched = true;
                        businessReportsVM.reportHtml = response.data ? response.data.html : '';
                    }
                    else {
                        businessReportsVM.isReportFetched = false;
                        businessReportsVM.reportHtml = response.data ? (response.data.html ? response.data.html : '') : '';
                    }
                });
            }

            businessReportsVM.ExportPdf = function () {
                var reportVM = PrepareParametersForService();
                reportVM.HTML = businessReportsVM.reportHtml;
                reportVM.PageOrientation = businessReportsVM.pageOrientation;
                ReportService.GeneratePdfFromHtml(reportVM);
            }

            businessReportsVM.ExportExcel = function () {
                var reportVM = PrepareParametersForService();
                ReportService.GetReportExcel(reportVM);
            }

            businessReportsVM.Clear = function () {
                businessReportsVM.selectedReportType = null;
            }

            //#endregion

        }]);
})();